import { CONDITIONS, type Condition } from 'types/notification';

/**
 * お知らせ登録フォームのフィールド
 */
export type NotificationFormFields = {
  /** お知らせタイトル */
  title: string;
  /** お知らせ本文 */
  message: string;
  /** お知らせ種別 */
  isHigh: boolean;
  /** 表示開始日 */
  startDate: string;
  /** 表示開始日 */
  endDate: string;
  /** 配信対象顧客 */
  condition: Condition;
};

/**
 * お知らせ登録フォームのフィールドの初期値
 */
export const initNotificationFormFields: NotificationFormFields = {
  title: '',
  message: '',
  isHigh: false,
  startDate: '',
  endDate: '',
  condition: CONDITIONS.ALL,
};
